module.exports = __webpack_public_path__ + "static/media/maria-maj-kowal.0c32fa46.png";